import axiosInstance from "./baseUrl";
import { cleanObject } from "../helpers";
import {
  AdminPublicContractListParams,
  PublicContractStatus,
} from "../redux/features/types/publicContractTypes";
import { PUBLIC_CONTRACT_STATUSES } from "../redux/features/types/publicContractTypes";

export const fetchAdminPublicContracts = async (
  params: AdminPublicContractListParams
) => {
  const response = await axiosInstance.get("/v1/public-contract/admin", {
    params: cleanObject(params),
  });
  return response.data;
};

export const fetchAdminPublicContractById = async (id: string) => {
  const response = await axiosInstance.get(`/v1/public-contract/admin/${id}`);
  return response.data;
};

export const updateAdminPublicContractStatus = async (
  id: string,
  status: PublicContractStatus
) => {
  const response = await axiosInstance.patch(
    `/v1/public-contract/admin/${id}/status`,
    { status }
  );
  return response.data;
};

export const fetchAdminPublicContractCounts = async () => {
  const queries: Array<PublicContractStatus | undefined> = [
    undefined,
    ...PUBLIC_CONTRACT_STATUSES,
  ];

  const results = await Promise.all(
    queries.map((status) =>
      axiosInstance.get("/v1/public-contract/admin", {
        params: cleanObject({ page: 1, limit: 1, status }),
      })
    )
  );

  return results.map((res) => res.data);
};
